import React from 'react';
import { FiPlay } from 'react-icons/fi';
import type { ChannelMediaResponse } from '@troia-v3/types';

export const FeaturedVideos: React.FC<{ items: ChannelMediaResponse[] }> = ({ items }) => {
  if (items.length === 0) return null;
  return (
    <div data-testid="cdash-featured">
      <span className="cdash-mlabel">Em destaque · Vídeos verticais</span>
      <div className="cdash-featured">
        {items.map((m) => {
          const first = m.assets[0];
          const inner = (
            <>
              {first?.storedImageUrl ? (
                <img src={first.storedImageUrl} alt="" />
              ) : first?.type === 'video' ? (
                <video src={first.mediaUrl} muted />
              ) : first?.thumbnailUrl ? (
                <img src={first.thumbnailUrl} alt="" />
              ) : first ? (
                <img src={first.mediaUrl} alt="" />
              ) : null}
              <span className="cdash-vvideo-play"><FiPlay size={22} /></span>
            </>
          );
          return m.permalink ? (
            <a className="cdash-vvideo" href={m.permalink} target="_blank" rel="noreferrer" key={m.id} data-testid={`cdash-vvideo-${m.id}`}>
              {inner}
            </a>
          ) : (
            <div className="cdash-vvideo" key={m.id} data-testid={`cdash-vvideo-${m.id}`}>
              {inner}
            </div>
          );
        })}
      </div>
    </div>
  );
};
